import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import { getContextReference } from "./getContextReference.js";
export function parseUseContext(decl, args, state, app, options) {
  if (args.length !== 1) {
    state.errors.push({
      message: "\"useContext()\" must have exactly one argument, but got ".concat(args.length),
      node: decl.node,
      severity: "error"
    });
    return null;
  }
  var firstArg = args[0];
  if (!firstArg.isIdentifier()) {
    state.errors.push({
      message: "\"useContext()\" argument must be an identifier, but got ".concat(firstArg.type),
      node: firstArg.node,
      severity: "error"
    });
    return null;
  }
  var contextRef = getContextReference(firstArg, state, app, options);
  if (!contextRef) {
    return null;
  }
  var declId = decl.get("id");
  if (!declId.isObjectPattern()) {
    return null;
  }
  var properties = declId.get("properties");
  var bindings = [];
  var _iterator = _createForOfIteratorHelper(properties),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var prop = _step.value;
      if (!prop.isObjectProperty()) {
        state.errors.push({
          message: "Unsupported property type in \"useContext()\" destructuring: ".concat(prop.type),
          node: prop.node,
          severity: "error"
        });
        continue;
      }
      if (prop.node.computed) {
        state.errors.push({
          message: "\"useContext()\" destructuring property cannot be computed",
          node: prop.node,
          severity: "error"
        });
        continue;
      }
      var key = prop.get("key");
      if (!key.isIdentifier()) {
        state.errors.push({
          message: "\"useContext()\" destructuring property key must be an identifier, but got ".concat(key.type),
          node: key.node,
          severity: "error"
        });
        continue;
      }
      var value = prop.get("value");
      if (!value.isIdentifier()) {
        state.errors.push({
          message: "\"useContext()\" destructuring property value must be an identifier, but got ".concat(value.type),
          node: value.node,
          severity: "error"
        });
        continue;
      }
      bindings.push({
        id: value.node,
        kind: "context",
        contextProvider: contextRef,
        contextKey: key.node.name
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return bindings;
}
//# sourceMappingURL=parseUseContext.js.map